import { Button, type ButtonProps as MuiButtonProps } from '@mui/material';
import React from 'react';

interface MuiDataTableButtonProps extends MuiButtonProps {
  text: string;
}

export default function MuiDataTableButton({
  onClick: handleButtonClick,
  text,
  ...props
}: MuiDataTableButtonProps) {
  const handleClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    // If there is an onClick callback fn, then preventDefault & stopPropagation
    if (handleButtonClick) {
      e.preventDefault();
      e.stopPropagation();
      handleButtonClick(e);
    }
  };

  return (
    <Button
      color="info"
      onClick={handleClick}
      sx={{
        textTransform: 'capitalize',
        textDecoration: 'underline',
      }}
      variant="text"
      {...props}
    >
      {text}
    </Button>
  );
}
